<template>
  <div class="logo" :style="rootStyles">
    <img src="@/assets/img/orca_logo_white.svg" height="20" />
    <span>labs</span>
  </div>
</template>

<script>
export default {
  name: 'Logo',

  props: {
    top: Number,
    left: Number,
    bottom: Number,
    right: Number,
    absolute: Boolean,
  },

  computed: {
    rootStyles() {
      return {
        position: this.absolute ? 'absolute' : null,
        top: this.top + 'px' || null,
        left: this.left + 'px' || null,
        bottom: this.bottom + 'px' || null,
        right: this.right + 'px' || null,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.logo {
  display: flex;
  padding-left: 8px;
  border-left: 5px solid hsl(353, 72%, 58%);
  align-items: flex-start;

  span {
    font-weight: 400;
    color: #686f78;
    line-height: 0.9;
    margin-left: 8px;
    @include font-size(18px);
  }
}
</style>
